import classNames from 'classnames';
import { memo } from 'react';
import { format } from 'date-fns-jalali/format';
import { isValid } from 'date-fns/isValid';
import { parse } from 'date-fns/parse';
import './reserveReport.css';

export interface DayNameProps {
  day: ReportDayEntity;
}

export const DAYS_MAP = {
  Saturday: 'شنبه',
  Sunday: 'یک‌شنبه',
  Monday: 'دوشنبه',
  Tuesday: 'سه‌شنبه',
  Wednesday: 'چهارشنبه',
  Thursday: 'پنج‌شنبه',
  Friday: 'جمعه',
};

function parseReportDate(value?: string) {
  const datePart = value?.trim().split(/[T\s+]/)[0];
  if (!datePart) return null;
  const parsed = parse(datePart, 'yyyy-MM-dd', new Date());
  return isValid(parsed) ? parsed : null;
}

const DayName = memo(({ day }: DayNameProps) => {

  const date = parseReportDate(day.date);

  const circleClasses = classNames(
    'w-[0.55rem] h-[0.55rem] rounded-full',
    day.mealTypes ? 'bg-primary-food' : 'bg-app-gray-darker'
  );

  return (
    <div>
      <div className="dayName-wrapper py-2 w-full">
        <div className="font-sm flex text-app-gray-darker items-center" style={{ gap: '0.15rem' }}>
          <span className={circleClasses} />
          <span className="w-14">{DAYS_MAP[day.day]}</span>
          <b className="text-base">{date ? format(date, 'd') : ''}</b>
          <span>{date ? format(date, 'MMMM') : ''}</span>
        </div>
        <div className="dayName-separator" />
      </div>
    </div>
  );
});

export default DayName;
